// extracted by mini-css-extract-plugin
export default {"darkGrey":"#73818a","green":"#44cc94","description":"description__3NoOh","productHeader":"productHeader__Oh7R6","productTitle":"productTitle__uSnhM","previousButton":"previousButton__3f0bw","location":"location__1prS-","column":"column__2pTrS","openBookerStickyContainer":"openBookerStickyContainer__1juK-","bookMeButton":"bookMeButton__2ua4g","price":"price__3poiE"};
    if(module.hot) {
      // 1764953357496
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  